import { Injectable, inject } from '@angular/core';
import { VasService } from './vas.service';
import { ViewName } from '@fpr/core/models/session.models';

interface OffersetRecord {
    offersetId: string;
    validOn: ViewName[];
    validOnRefresh: ViewName[];
}

@Injectable({
    providedIn: 'root'
})
export class OfferManager {
    private readonly vasService = inject(VasService);


    private readonly SESSION_OFFERSET_RECORDS_NAME = 'fpr.offersetRecords';
    private offersetRecords: OffersetRecord[] = [];

    addOffersetRecord(offersetRecord: OffersetRecord): void {
        this.offersetRecords.push(offersetRecord);
        this.setOffersetRecordSession();
    }

    checkOffersetRecords(currentView: ViewName): void {

        const offersToDelete: OffersetRecord[] = [];

        this.offersetRecords.forEach(offersetRecord => {
            if (!offersetRecord.validOn.includes(currentView)) {
                this.returnOffersetToInventory(offersetRecord.offersetId);
                offersToDelete.push(offersetRecord);
            }
        });

        this.offersetRecords = this.offersetRecords.filter(offer => offersToDelete.includes(offer));
        this.setOffersetRecordSession();

    }

    checkSessionOffersetRecords(currentView: ViewName): void {

        const sessionOffers: OffersetRecord[] = JSON.parse(sessionStorage.getItem(this.SESSION_OFFERSET_RECORDS_NAME)) || [];

        sessionOffers.forEach(offersetRecord => {
            if (!offersetRecord.validOnRefresh.includes(currentView)) {
                this.returnOffersetToInventory(offersetRecord.offersetId);
            } else  {
                this.offersetRecords.push(offersetRecord);
            }
        });

        this.setOffersetRecordSession();

    }

    deleteOffersetRecord(offersetId: string, makeServiceCall = true): void {
        if (makeServiceCall) {
            this.returnOffersetToInventory(offersetId);
        }
        this.offersetRecords = this.offersetRecords
            .filter(offersetRecord => offersetRecord.offersetId !== offersetId);
        this.setOffersetRecordSession();
    }

    private returnOffersetToInventory(offersetId: string): void {
        this.vasService
            .delete(`/v1/offers/${offersetId}`, { skipErrorInterceptor: true })
            .subscribe()
            .unsubscribe();
    }

    private setOffersetRecordSession(): void {
        sessionStorage.setItem(this.SESSION_OFFERSET_RECORDS_NAME, JSON.stringify(this.offersetRecords));
    }

}
